import React from "react";

const UserCreate = () => {
  return <div>UserCreate</div>;
};

export default UserCreate;
